const config = {
  appName: "CheeksAndLips",
  company: "ZenBoost OÜ",
  domain: "cheeksandlips.com",
  regNum: "17053006",
  address:
    "Harju county, Tallinn, Haaberst district, Paldiski street 199a, 13517",
  country: "Estonia",
  mailTo: "support@cheeksandlips.com",
  phone: "+372 668 3213",
  descriptor:
    "cksndbill.com | cksndpay.com | cksndli.com | cheeksandlips | Tallinn cheeksandlips.info | cheeklippay.com | chiklippay.com",

  nextPaymentDay: "3rd",
  nextPaymentDayTwo: "7th",
  rebillDaysPrice: "28",
  rebillPrice: "69.49",

  productTrialPrices: [1.95, 9.99],
  productRebillPrices: "69.49",
  productSubscriptionDays: [3, 7],
};

export default config
